// extracted by mini-css-extract-plugin
export default {"searchWrapper":"FilterSearch_searchWrapper__S5HwG"};